module.exports = __webpack_public_path__ + "assets/img/3.7faa2371.png";